import PaymentThankYouLoggedInContent from './PaymentThankYouLoggedInContent';

export default PaymentThankYouLoggedInContent;
